import { isEmpty } from '../is-empty'
import { getIn } from '../path-helper'
import { Settings } from '@reapit-sales/api-v2'

/**
 * Checks if a feature is enabled in the CRM modernisation settings
 * @param feature - The feature name to check
 * @param settings - The user settings object
 * @returns true if the feature is enabled, false otherwise
 */
export const featureToggle = (feature: string, settings: Settings): boolean => {
  const featureValue = getIn(['otherFeatures', 'crmModernisation', feature])(settings)

  // Feature is enabled if it exists, is not empty, and is not explicitly false
  return !isEmpty(featureValue) && featureValue !== false
}
